<template>
	<inertia-head title="Transactions" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Transactions</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						View All Transactions
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block block-rounded shadow mb-1">
			<div class="block-content block-content-full">
				<form @submit.prevent="submit">
					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label for="date" class="form-label">Request Date</label>
								<flat-pickr
									v-model="form.date"
									id="date"
									class="form-control"
									:config="{
										altInput: true,
										altFormat: 'M j, Y',
										dateFormat: 'Y-m-d',
										wrap: true,
										mode: 'range',
									}"
								/>
							</div>
						</div>
						<div class="col space-x-1 d-flex align-items-end">
							<button
								type="submit"
								class="btn btn-alt-primary"
								:disabled="form.processing || !form.isDirty"
							>
								Refine Result
							</button>
							<button
								@click="$inertia.visit(route('admin.transactions.index'))"
								type="button"
								class="btn btn-alt-secondary"
							>
								Reset
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="block-content">
				<div class="table-responsive">
					<table
						class="table table-striped table-borderless table-hover table-vcenter"
					>
						<thead class="text-center">
							<tr>
								<th>#</th>
								<th>TXNID</th>
								<th>REQUEST DATE</th>
								<th>FULLNAME</th>
								<th>MOBILE</th>
								<th>BIRTHDAY</th>
								<th>COURSE</th>
								<th>AMOUNT</th>
								<th>STATUS</th>
								<th>DONE DATE</th>
								<th>EXPIRY</th>
								<th>SOURCE</th>
							</tr>
						</thead>
						<tbody class="fs-sm text-center">
							<tr
								v-for="(transaction, index) in transactions.data"
								:key="transaction.counter"
							>
								<td>{{ index + transactions.from }}</td>
								<td>
									<small>{{ transaction.txnid }}</small>
								</td>
								<td>{{ transaction.rdate }}</td>
								<td>
									<span class="fw-semibold">{{ transaction.fullname }}</span>
									<div class="clearfix"></div>
									<span>{{ transaction.email }}</span>
								</td>
								<td>{{ transaction.mobile }}</td>
								<td>{{ transaction.bday ?? '-' }}</td>
								<td>
									<a
										href="javascript:void(0);"
										class="text-info fw-semibold"
										data-bs-toggle="tooltip"
										data-bs-placement="bottom"
										:title="transaction.course"
									>
										{{ transaction.codetype }}
									</a>
								</td>
								<td class="text-end">
									<p class="mb-0">&#8369;{{ transaction.amount }}</p>
									<p class="mb-0">
										<small>-{{ transaction.mop }}</small>
									</p>
								</td>
								<td>{{ transaction.status ?? '-' }}</td>
								<td>{{ transaction.ddate }}</td>
								<td>{{ transaction.cdate }}</td>
								<td>
									<small>{{ transaction.source }}</small>
								</td>
							</tr>
							<tr v-if="transactions.data.length == 0">
								<td colspan="13" class="text-center">NO DATA FOUND</td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination :collections="transactions" />
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	layout: AuthLayout,
	props: {
		transactions: Object,
		filters: Object,
	},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const form = useForm({
			date: props.filters.date,
		})

		const submit = () => {
			form.get(route('admin.transactions.index'), {
				preserveState: true,
				preserveScroll: true,
				only: ['transactions', 'filters'],
			})
		}

		return {
			form,
			submit,
		}
	},
}
</script>
